import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import * as PIXI from "pixi.js";
import { GameStyle } from "../style/GameStyle";
/**
 * Main.ts
 */
export class Main extends AbstractGameView {
    createFactory(factory) {
        this.factory = factory;
    }
    addEventListeners() {
        super.addEventListeners();
    }
    create() {
        super.create();
        this.createBackground();
        this.createReels();
        this.createTicket();
        this.createPortraitPayTable();
        this.createSpinsRemaining();
        this.createPayTable();
        this.createFreeSpinsRainbowOverlay();
        this.createControlPanel();
        this.createFreeSpinsCounter();
        this.createFeatureGreenFish();
        this.createFeatureRedFish();
        this.createFeaturePurpleFish();
        this.createFeatureFishFood();
        this.createFeatureGoldFish();
        this.createBigWin();
        this.createFeatureSelector();
        this.createWinDisplay();
        this.createArcadeWheel();
        this.createCoinWinOverlay();
        this.createFreeSpinsOverlay();
        this.createScatterWin();
        this.createFullHouse();
        this.createGameMainTransition();
        this.createFeatureIntro();
        this.createMasks();
    }
    createFreeSpinsRainbowOverlay() {
        this.freeSpinsRainbowOverlay = this.factory.createFreeSpinsRainbowOverlay();
        this.addComponent(this.freeSpinsRainbowOverlay);
    }
    createFreeSpinsCounter() {
        this.freeSpinsCounter = this.factory.createFreeSpinsCounter();
        this.addComponent(this.freeSpinsCounter);
    }
    postCreate() {
        super.postCreate();
        Logger.addObjectRef(this, "Main");
    }
    createFeatureGreenFish() {
        this.featureGreenFish = this.factory.createFeatureGreenFish();
        this.addComponent(this.featureGreenFish);
    }
    createFeatureRedFish() {
        this.featureRedFish = this.factory.createFeatureRedFish();
        this.addComponent(this.featureRedFish);
    }
    createFeaturePurpleFish() {
        this.featurePurpleFish = this.factory.createFeaturePurpleFish();
        this.addComponent(this.featurePurpleFish);
    }
    createFeatureFishFood() {
        this.featureFishFood = this.factory.createFeatureFishFood();
        this.addComponent(this.featureFishFood);
    }
    createFeatureGoldFish() {
        this.featureGoldFish = this.factory.createFeatureGoldFish();
        this.addComponent(this.featureGoldFish);
    }
    createBigWin() {
        this.bigWin = this.factory.createBigWin();
        this.addComponent(this.bigWin);
    }
    createScatterWin() {
        this.scatterWin = this.factory.createScatterWin();
        this.addComponent(this.scatterWin);
    }
    createFullHouse() {
        this.fullHouse = this.factory.createFullHouse();
        this.addComponent(this.fullHouse);
    }
    createFeatureIntro() {
        this.featureIntro = this.factory.createFeatureIntro();
        this.addComponent(this.featureIntro);
    }
    createBackground() {
        this.background = this.factory.createGameBackground();
        this.addComponent(this.background);
    }
    createFeatureSelector() {
        this.featureSelector = this.factory.createFeatureSelector();
        this.addComponent(this.featureSelector);
    }
    createArcadeWheel() {
        this.arcadeWheel = this.factory.createArcadeWheel();
        this.addComponent(this.arcadeWheel);
    }
    createWinDisplay() {
        this.winDisplay = this.factory.createWinDisplay();
        this.addComponent(this.winDisplay);
    }
    createTicket() {
        this.ticket = this.factory.createTicket();
        this.addComponent(this.ticket);
    }
    createReels() {
        this.reels = this.factory.createReels();
        this.addComponent(this.reels);
    }
    createControlPanel() {
        this.controlPanel = this.factory.createControlPanel();
        this.addComponent(this.controlPanel);
    }
    createPayTable() {
        this.payTable = this.factory.createPayTable();
        this.payTable.setTrackingId(GameStyle.PAY_TABLE);
        this.addComponent(this.payTable);
    }
    createPortraitPayTable() {
        this.portraitPayTable = this.factory.createPortraitPayTable();
        this.addComponent(this.portraitPayTable);
    }
    createSpinsRemaining() {
        this.spinsRemaining = this.factory.createSpinsRemaining();
        this.addComponent(this.spinsRemaining);
    }
    createFreeSpinsOverlay() {
        this.freeSpinsOverlay = this.factory.createFreeSpinsOverlay();
        this.addComponent(this.freeSpinsOverlay);
    }
    createGameMainTransition() {
        this.gameMainTransition = this.factory.createGameMainTransition();
        this.addComponent(this.gameMainTransition);
        // this.uiFilters.setValue(OrientationType.LANDSCAPE, [this.gameMainTransition.getFilter()]);
        // this.uiFilters.setValue(OrientationType.PORTRAIT, [this.gameMainTransition.getFilter()]);
    }
    createCoinWinOverlay() {
        this.coinWinOverlay = this.factory.createCoinWinOverlay();
        this.addComponent(this.coinWinOverlay);
    }
    createMasks() {
        // this.maskGraphics = new PIXI.Graphics();
        // this.maskGraphics.beginFill(0xFFFFFF, 1);
        // this.maskGraphics.drawRect(-1, -1, 2, 2);
        // this.maskGraphics.endFill();
        // this.addChild(this.maskGraphics);
        // this.mask = this.maskGraphics;
    }
    addComponent(component, behindComponent) {
        if (component) {
            if (behindComponent) {
                this.addChildAt(component, this.getChildIndex(behindComponent));
            }
            else {
                this.addChild(component);
            }
        }
    }
    removeComponent(component) {
        if (component) {
            this.removeChild(component);
        }
    }
    handleResize(event) {
        this.adjustMaskSize();
        if (this.renderer.isLandscape()) {
            this.scaleLandscape();
        }
        else {
            this.scalePortrait();
        }
        let rendererSize = this.renderer.getGameSize();
        this.position.set(rendererSize.x / 2, rendererSize.y / 2);
        this.pivot.set(rendererSize.x / 2, rendererSize.y / 2);
    }
    handleRotate(event) {
        super.handleRotate(event);
    }
    scaleLandscape() {
        let newScale = new PIXI.Point(1, 1);
        let x = (this.renderer.getWindowSize().x / this.renderer.getHolder().scale.x);
        let viewportWidth = this.renderer.getViewport().width;
        let minScale = 0.5;
        if (x < viewportWidth) {
            let scale = Math.max(minScale, x / viewportWidth);
            newScale = new PIXI.Point(scale, scale);
        }
        this.scale.set(newScale.x, newScale.y);
    }
    scalePortrait() {
        let newScale = new PIXI.Point(1, 1);
        let y = (this.renderer.getWindowSize().y / this.renderer.getHolder().scale.y);
        let viewportHeight = this.renderer.getViewport().height;
        let minScale = 0.6;
        if (y < viewportHeight) {
            let scale = Math.max(minScale, y / viewportHeight);
            newScale = new PIXI.Point(scale, scale);
        }
        this.scale.set(newScale.x, newScale.y);
    }
    _adjustMaskSize() {
        return true;
        /*if (this.parent && this.renderer.getStage().height && this.renderer.getStage().width) {
            // GM-2218 - DO NOT CALL updateTransform() ON MAIN. This will create every child TitanText bitmap at once, causing an iOS crash
            // this.updateTransform();
            this.maskGraphics.scale.set(1);
            const transformedScale: PIXI.Point = this.getTransformedScale(this, this.maskGraphics.scale);
            const height = window.innerHeight / transformedScale.y;
            const width = window.innerWidth / transformedScale.x;
            const scaleY = height / this.maskGraphics.height;
            const scaleX = width / this.maskGraphics.width;
            this.maskGraphics.scale.set(scaleX, scaleY);
            this.maskGraphics.position.set(this.renderer.getViewport().width / 2, this.renderer.getViewport().height / 2);

            // just clamp the mask to viewport.
            this.maskGraphics.width = this.renderer.getViewport().width;
            this.maskGraphics.height = this.renderer.getViewport().height;

            return true;
        }
        return false;*/
    }
    async adjustMaskSize() {
        /*
        while (!this._adjustMaskSize()) {
            await gsap.delayedCall(0.016, () => { Logger.verbose("Main.ts retrigger mask scaling") });
        }
        */
    }
}
export class MainDisplayEvents {
}
MainDisplayEvents.TRANSITION_TO_FEATURE = new EventObject("MainDisplayEvents.TRANSITION_TO_FEATURE");
MainDisplayEvents.TRANSITION_FROM_FEATURE = new EventObject("MainDisplayEvents.TRANSITION_FROM_FEATURE");
//# sourceMappingURL=Main.js.map